'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppAuthData$AdminUser(user) {
  this.Lapp_data_AppAuthData$AdminUser__f_user = null;
  this.Lapp_data_AppAuthData$AdminUser__f_user = user;
}
export { $c_Lapp_data_AppAuthData$AdminUser as $c_Lapp_data_AppAuthData$AdminUser };
$c_Lapp_data_AppAuthData$AdminUser.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppAuthData$AdminUser.prototype.constructor = $c_Lapp_data_AppAuthData$AdminUser;
/** @constructor */
function $h_Lapp_data_AppAuthData$AdminUser() {
}
export { $h_Lapp_data_AppAuthData$AdminUser as $h_Lapp_data_AppAuthData$AdminUser };
$h_Lapp_data_AppAuthData$AdminUser.prototype = $c_Lapp_data_AppAuthData$AdminUser.prototype;
$c_Lapp_data_AppAuthData$AdminUser.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_AppAuthData$AdminUser.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 422353753, true);
});
$c_Lapp_data_AppAuthData$AdminUser.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppAuthData$AdminUser)) {
    var x = this.Lapp_data_AppAuthData$AdminUser__f_user;
    var x$2 = x$0.Lapp_data_AppAuthData$AdminUser__f_user;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_data_AppAuthData$AdminUser.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_AppAuthData$AdminUser.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_data_AppAuthData$AdminUser.prototype.productPrefix__T = (function() {
  return "AdminUser";
});
$c_Lapp_data_AppAuthData$AdminUser.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_data_AppAuthData$AdminUser__f_user;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_AppAuthData$AdminUser.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "user";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_AppAuthData$AdminUser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_AppAuthData$AdminUser)));
}
export { $isArrayOf_Lapp_data_AppAuthData$AdminUser as $isArrayOf_Lapp_data_AppAuthData$AdminUser };
var $d_Lapp_data_AppAuthData$AdminUser = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppAuthData$AdminUser, "app.data.AppAuthData$AdminUser", ({
  Lapp_data_AppAuthData$AdminUser: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lapp_data_AppAuthData: 1
}));
export { $d_Lapp_data_AppAuthData$AdminUser as $d_Lapp_data_AppAuthData$AdminUser };
//# sourceMappingURL=app.data.-App-Auth-Data$-Admin-User.js.map
